import React from "react";

export const EncasaProperty = () => {
  return (<div className=""></div>);
};